import { Box } from '@components/Box';
import { styled } from '@styledComponents';
import { themeColor, themeMediaQuery, themeSpace } from '@utils/styledTheme.util';
import { AVATAR_SIZE } from '@sections/find/HeroSection/components/ResultListItem/ResultListItem.styles';

const NAME_HEIGHT = 51;
const NAME_HEIGHT_MOBILE = 32;

export const ListItemWrapperPlaceholder = styled(Box)`
  width: 100%;
  display: flex;
  flex-direction: row;
  padding-top: ${themeSpace(6)};
  padding-bottom: ${themeSpace(6)};
  align-items: center;
`;

export const DetailFieldPlaceholder = styled(Box)`
  width: 90%;
  display: flex;
  flex-direction: row;
  ${themeMediaQuery('below_sm')} {
    width: 70%;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
  }
  ${themeMediaQuery('tablet')} {
    width: 85%;
  }
`;

export const NameFieldPlaceholder = styled(Box)`
  background: ${themeColor('mono4')};
  border-radius: ${themeSpace(3)};
  width: 50%;
  height: ${NAME_HEIGHT}px;
  margin-right: ${themeSpace(4)};
  ${themeMediaQuery('below_sm')} {
    width: 100%;
    height: ${NAME_HEIGHT_MOBILE}px;
    margin-right: ${themeSpace(0)};
    margin-bottom: ${themeSpace(1)};
  }
`;

export const DateFieldPlaceholder = styled(Box)`
  display: inline-flex;
  width: 80%;
  height: ${NAME_HEIGHT}px;
  background: ${themeColor('mono4')};
  border-radius: ${themeSpace(3)};
  margin-right: ${themeSpace(5)};
  ${themeMediaQuery('below_sm')} {
    display: block;
    margin-bottom: ${themeSpace(5)};
    margin-right: ${themeSpace(0)};
    width: 100%;
    height: ${NAME_HEIGHT_MOBILE}px;
  }
`;

export const LinksWrapperPlaceholder = styled(Box)`
  flex-direction: row;
  justify-content: space-between;
  width: 50%;
  height: ${NAME_HEIGHT}px;
  background: ${themeColor('mono4')};
  border-radius: ${themeSpace(3)};
  ${themeMediaQuery('below_sm')} {
    width: 100%;
    height: ${themeSpace(7)};
    padding-left: ${themeSpace(0)};
    padding-right: ${themeSpace(0)};
  }
`;

export const ProfileWrapperPlaceholder = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-right: ${themeSpace(7)};
  ${themeMediaQuery('below_sm')} {
    width: 100%;
    margin-right: ${themeSpace(0)};
  }
`;

export const ImgWrapperPlaceholder = styled.div`
  width: ${AVATAR_SIZE}px;
  height: ${AVATAR_SIZE}px;
  border-radius: 50%;
  overflow: auto;
  margin-right: ${themeSpace(6)};
  background: linear-gradient(0deg, ${themeColor('mono4')}, ${themeColor('mono4')});
`;
